<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <div class="items-center gap-x-3 grid grid-cols-2">
        <el-form-item
          label="日期"
          prop="dates"
          :rules="[
            { required: true, message: '请输入选择日期', trigger: 'blur' },
          ]"
        >
          <el-date-picker
            v-model="state.model.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item
          label="会议类型"
          prop="d_meeting_type_id"
          :rules="[
            { required: true, message: '请选择会议类型', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.model.d_meeting_type_id"
            :empty-values="[null, undefined, 0]"
          >
            <el-option
              v-for="item in state.type_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadType"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
      </div>
      <ul class="items-center gap-x-3 grid grid-cols-2">
        <el-form-item
          label="报名开始时间"
          prop="signup_start_time_date"
          :rules="[
            { required: true, message: '请选择报名开始时间', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!state.model.signup_start_time_time)
                  return callback(new Error('请选择报名开始时间'));
                else callback();
              },
              trigger: 'blur',
            },
          ]"
        >
          <div class="grid items-center gap-x-2 grid-cols-2">
            <el-date-picker
              v-model="state.model.signup_start_time_date"
              type="date"
              placeholder="报名开始日期"
              value-format="YYYY-MM-DD"
              class="!w-full"
            />
            <el-time-select
              v-model="state.model.signup_start_time_time"
              start="05:00"
              step="00:30"
              end="24:00"
              class="!w-full"
              placeholder="报名开始时间"
            />
            <!-- <el-time-picker
              v-model="state.model.signup_start_time_time"
              placeholder="--请选择--"
              format="HH:mm"
              value-format="HH:mm"
            /> -->
          </div>
        </el-form-item>
        <el-form-item
          label="报名截止时间"
          prop="signup_end_time_date"
          :rules="[
            { required: true, message: '请选择报名截止时间', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!state.model.signup_end_time_time)
                  return callback(new Error('请选择报名截止时间'));
                else callback();
              },
              trigger: 'blur',
            },
          ]"
        >
          <div class="grid items-center gap-x-2 grid-cols-2">
            <el-date-picker
              v-model="state.model.signup_end_time_date"
              type="date"
              placeholder="报名截止日期"
              value-format="YYYY-MM-DD"
              class="!w-full"
            />
            <el-time-select
              v-model="state.model.signup_end_time_time"
              start="05:00"
              step="00:30"
              end="24:00"
              class="!w-full"
              placeholder="报名截止时间"
            />
          </div>
        </el-form-item>
      </ul>
      <ul class="items-center gap-x-3 grid grid-cols-3">
        <el-form-item label="住宿">
          <el-input v-model="state.model.accommodation"></el-input>
        </el-form-item>
        <el-form-item label="用餐">
          <el-input v-model="state.model.catering"></el-input>
        </el-form-item>
        <el-form-item
          label="项目经理"
          prop="belonger_id"
          :rules="[
            { required: true, message: '请选择项目经理', trigger: 'blur' },
          ]"
        >
          <c_userselect
            v-model="state.model.belonger_id"
            @change:item="
              (item) => {
                state.model.belonger_department_id = item.department_id;
              }
            "
          />
        </el-form-item>
      </ul>
      <el-form-item
        label="会议标签"
        prop="belonger_id"
        :rules="[
          { required: true, message: '请选择会议类型', trigger: 'blur' },
        ]"
      >
        <el-select v-model="state.model.d_meeting_tag_json" multiple>
          <el-option
            v-for="item in state.tag_data"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadTag"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <ul class="grid grid-cols-5 gap-x-3">
        <el-form-item
          label="设计师提成系数"
          prop="designer_commission_rate"
          :rules="[
            {
              required: true,
              message: '请输入设计师提成系数',
              trigger: 'blur',
            },
          ]"
        >
          <el-input-number
            v-model="state.model.designer_commission_rate"
            class="number-input-left number-input-suffix !w-full"
            suffix="%"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="项目经理提成系数"
          prop="manager_commission_rate"
          :rules="[
            {
              required: true,
              message: '请输入项目经理提成系数',
              trigger: 'blur',
            },
          ]"
        >
          <el-input-number
            v-model="state.model.manager_commission_rate"
            class="number-input-left number-input-suffix !w-full"
            suffix="%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="服务费比例">
          <el-input-number
            v-model="state.model.service_fee_rate"
            class="number-input-left number-input-suffix !w-full"
            suffix="%"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="报账税率"
          prop="tax_fee_rate"
          :rules="[
            { required: true, message: '请输入报账税率', trigger: 'blur' },
          ]"
        >
          <el-input-number
            v-model="state.model.tax_fee_rate"
            class="number-input-left number-input-suffix !w-full"
            suffix="%"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="成本税率"
          prop="cost_tax_fee_rate"
          :rules="[
            { required: true, message: '请输入成本税率', trigger: 'blur' },
          ]"
        >
          <el-input-number
            v-model="state.model.cost_tax_fee_rate"
            class="number-input-left number-input-suffix !w-full"
            suffix="%"
          ></el-input-number>
        </el-form-item>
      </ul>
      <ul class="grid grid-cols-2 gap-x-3">
        <el-form-item>
          <template #label>
            <text>主办单位</text>
            <text class="text-orange-400 text-xs ml-1">多个单位用逗号隔开</text>
          </template>
          <el-input
            v-model="state.model.sponsor"
            type="textarea"
            :autosize="{ minRows: 2 }"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <template #label>
            <text>承办单位</text>
            <text class="text-orange-400 text-xs ml-1">多个单位用逗号隔开</text>
          </template>
          <el-input
            v-model="state.model.organizer"
            type="textarea"
            :autosize="{ minRows: 2 }"
          ></el-input>
        </el-form-item>
      </ul>
      <el-form-item
        prop="bill_title"
        :rules="[
          { required: true, message: '请输入单据抬头', trigger: 'blur' },
        ]"
      >
        <template #label>
          <text>单据抬头</text>
          <!-- <text class="ml-2 text-xs text-gray-400">一般填写公司名称</text> -->
        </template>
        <el-input v-model="state.model.bill_title"></el-input>
      </el-form-item>
      <ul class="grid gap-x-3" style="grid-template-columns: 1fr 2fr">
        <el-form-item
          label="会议所在地"
          prop="area"
          :rules="[
            { required: true, message: '请选择会议所在地', trigger: 'blur' },
          ]"
          class="flex-1"
        >
          <el-cascader
            v-model="state.model.area"
            :options="area"
            filterable
            :props="{
              value: 'name',
              label: 'name',
            }"
            class="!w-full"
          />
        </el-form-item>
        <el-form-item
          label="详细地址"
          prop="address"
          :rules="[
            { required: true, message: '请输入详细地址', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
      </ul>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import area from "@/assets/json/pca-code.json";
import { dayjs } from "element-plus";
import {
  dic_getMeetingType,
  dic_getMeetingTag,
  dic_getCommissionRate,
} from "@/http/data";
import { meeting_detail, meeting_add, meeting_edit } from "@/http/meeting";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoadType();
      onLoadTag();
      onLoadTcbl();
      if (props.id) {
        meeting_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.area = [data.province, data.city, data.district];
            state.model.dates = [data.start_date, data.end_date];

            const signup_start_times = data.signup_start_time.split(" ");
            if (signup_start_times.length == 2) {
              state.model.signup_start_time_date = signup_start_times[0];
              state.model.signup_start_time_time = dayjs(
                signup_start_times[1],
                "HH:mm:ss",
              ).format("HH:mm");
            }

            const signup_end_times = data.signup_end_time.split(" ");
            if (signup_end_times.length == 2) {
              state.model.signup_end_time_date = signup_end_times[0];
              state.model.signup_end_time_time = dayjs(
                signup_end_times[1],
                "HH:mm:ss",
              ).format("HH:mm");
            }
          }
        });
      }
    });

    //获取会议类型
    const onLoadType = () => {
      dic_getMeetingType().then((res) => {
        if (res.status == 200) {
          state.type_data = res.data.data;
        }
      });
    };

    //获取会议标签
    const onLoadTag = () => {
      dic_getMeetingTag().then((res) => {
        if (res.status == 200) {
          state.tag_data = res.data.data;
        }
      });
    };

    //获取提成比例
    const onLoadTcbl = () => {
      dic_getCommissionRate().then((res) => {
        if (res.status == 200) {
          state.tcbl_data = res.data.data;
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.model.area?.length == 3) {
            state.model.province = state.model.area[0];
            state.model.city = state.model.area[1];
            state.model.district = state.model.area[2];
          }

          if (state.model.dates?.length == 2) {
            state.model.start_date = state.model.dates[0];
            state.model.end_date = state.model.dates[1];
          }

          state.model.signup_end_time =
            state.model.signup_end_time_date +
            " " +
            state.model.signup_end_time_time;

          state.model.signup_start_time = dayjs(
            state.model.signup_start_time_date +
              " " +
              state.model.signup_start_time_time,
          ).format("YYYY-MM-DD HH:mm:ss");

          state.model.signup_end_time = dayjs(
            state.model.signup_end_time_date +
              " " +
              state.model.signup_end_time_time,
          ).format("YYYY-MM-DD HH:mm:ss");

          if (props.id) {
            meeting_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      area,
      formDom,
      onSubmit,
      onLoadTcbl,
      onLoadType,
      onLoadTag,
    };
  },
};
</script>
<style scoped></style>
